// IMPORT Components

import Home from '../views/Home';
import RegisterDeviation from '../views/RegisterDeviation';
import UndoDeviation from '../views/UndoDeviation';
import CycleCount from '../views/CycleCount';

import Loodsopname from "../views/loodsopname/Loodsopname";
import ScanTraceableProduct from "../views/trackAndTrace/ScanTraceableProduct";
import TrackAndTrace from "../views/trackAndTrace/TrackAndTrace";

import AdminRoutes from './routes/admin';
import LoadingRoutes from './routes/loading';
import UnloadingRoutes from './routes/unloading';
import StockLocationChanges from './routes/stockLocationChange';
import Login from "@/views/Login.vue";
import Users from "@/views/teamlead/Users.vue"

export default [
  {path: '/', name: 'home', component: Home},
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {path: '/callback', name: 'cb', component: Home},
  {path: '/register-deviation', name: 'registerDeviation', component: RegisterDeviation, props: true},
  {path: '/undo-deviation', name: 'UndoDeviation', component: UndoDeviation, props: true},
  {path: '/cycle-count', name: 'cycle-count', component: CycleCount, props: false},
  {path: '/users', name: 'users', component: Users, props: false},
  {
    path: '/teamlead/loodsopname',
    name: 'loodsopname',
    component: Loodsopname
  },
  {
    path: '/trackandtrace/scan',
    name: 'ScanTraceableProduct',
    component: ScanTraceableProduct
  },
  {
    path: '/trackandtrace/:productNumber',
    name: 'TrackAndTrace',
    component: TrackAndTrace,
    props: true
  },
  ...AdminRoutes,
  ...LoadingRoutes,
  ...UnloadingRoutes,
  ...StockLocationChanges,


  {path: '*', redirect: '/'}

];
